// https://davestewart.github.io/vuex-pathify/#/setup/config

import pathify from 'vuex-pathify';

// options
pathify.options.mapping = 'simple';
pathify.options.strict = true;

export default pathify;
